// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perf-chart-wrapper {
    width: 100%;
}

.perf-svg {
    width: 100%;
    height: 180px;
    display: block;
    overflow: visible;
}

.perf-dot {
    cursor: pointer;
    transition: r 0.15s ease;
}

.perf-dot:hover {
    r: 7;
}

.perf-legend {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 10px;
    font-size: 0.78rem;
    color: var(--text-secondary, #64748b);
    flex-wrap: wrap;
}

.perf-legend-item {
    display: flex;
    align-items: center;
    gap: 5px;
}

.perf-dot-small {
    display: inline-block;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    border: 2px solid white;
    box-shadow: 0 0 0 1px currentColor;
}

.perf-legend-win  { color: var(--brand-accent); }
.perf-legend-loss { color: #f43f5e; }

.perf-legend-score {
    margin-left: auto;
    font-weight: 600;
    color: var(--text-primary, #0f172a);
}

.perf-empty {
    padding: 32px 0;
    text-align: center;
    color: var(--text-secondary, #64748b);
    font-size: 0.88rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/PerformanceChart.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,IAAI;AACR;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA,oBAAoB,0BAA0B,EAAE;AAChD,oBAAoB,cAAc,EAAE;;AAEpC;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;AACtB","sourcesContent":[".perf-chart-wrapper {\n    width: 100%;\n}\n\n.perf-svg {\n    width: 100%;\n    height: 180px;\n    display: block;\n    overflow: visible;\n}\n\n.perf-dot {\n    cursor: pointer;\n    transition: r 0.15s ease;\n}\n\n.perf-dot:hover {\n    r: 7;\n}\n\n.perf-legend {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-top: 10px;\n    font-size: 0.78rem;\n    color: var(--text-secondary, #64748b);\n    flex-wrap: wrap;\n}\n\n.perf-legend-item {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.perf-dot-small {\n    display: inline-block;\n    width: 9px;\n    height: 9px;\n    border-radius: 50%;\n    border: 2px solid white;\n    box-shadow: 0 0 0 1px currentColor;\n}\n\n.perf-legend-win  { color: var(--brand-accent); }\n.perf-legend-loss { color: #f43f5e; }\n\n.perf-legend-score {\n    margin-left: auto;\n    font-weight: 600;\n    color: var(--text-primary, #0f172a);\n}\n\n.perf-empty {\n    padding: 32px 0;\n    text-align: center;\n    color: var(--text-secondary, #64748b);\n    font-size: 0.88rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
